module.exports = __webpack_public_path__ + "img/download.988b32f0.svg";